import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { eswiUtils } from "@/tra/tancis/eswi/comn";
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage } from "@/comn/hooks";
import {APIS, URLS, SF_EXTAUTH_SRCH, SG_EXT_USR_LIST} from "@/tra/tancis/ptli/usr/extauth/services/PtliExtAuthService";



export const PTLI0924001Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptli0050", "auth_ptlianyADM"],
    });                             // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { usrDmnId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!



    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        extAuthSrch : useForm({ defaultSchema: SF_EXTAUTH_SRCH })
    }

     /*
         * Declaration Grid
         * !== Grid 정의 ==!
         */
   const grid = {
         gridExtUsrList : useGrid({
            defaultSchema: SG_EXT_USR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size
        })
    }
    

    /*
    * Declaration Fetch
    * !== Fetch 정의 ==!
    */
    const fetch = {
        getExtUsrList : useFetch({
            api       : (page = grid.gridExtUsrList.page, size = grid.gridExtUsrList.size) => APIS.getExtUsrList(form.extAuthSrch.getValues(), page, size),
            enabled   : form.extAuthSrch.isSubmitted,
            key       : [grid.gridExtUsrList.page, grid.gridExtUsrList.size],
            onSuccess : () => {
                setStore(pgeUid, {
                    ...pgeStore,
                    form: form.extAuthSrch.getValues(),
                    page: grid.gridExtUsrList.page,
                    size: grid.gridExtUsrList.size,
                });
            },
            onError   : () => modal.openModal({content: "msg.com.00025"}) // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    }
    /*
    * Declaration Event Handler
    * !== 이벤트 핸들러 정의 ==!
    */

    const handler = {
        onSrchClick : form.extAuthSrch.handleSubmit(() => fetch.getExtUsrList.fetch()),
        onClear: () => {
            form.extAuthSrch.clearValues();
       }
    }

    const render = {
        extUsrList: {
            cell: {
                xtrnUsrIdntfNo : (props: any) => {
                    const { value, rowValues } = props;
                    return ( <Link to={`${URLS.ptli0924002s}/${rowValues.xtrnUsrUuid}`}>{value}</Link> )
                }
            }
        }
    }

    useEffect(() => {  
        pgeStore?.form && form.extAuthSrch.setValues(pgeStore.form);
        pgeStore?.form && handler.onSrchClick();
    }, []);

    return (
        <Page> 
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.extAuthSrch.schema.xtrnUsrIdntfNo}  />
                            <Group.Control {...form.extAuthSrch.schema.usrNm}/>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.extAuthSrch.schema.usrEmlAddr}/>
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={handler.onClear}/>
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchClick}/>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Title title={"T_CSTM_OFCR_LIST"}/>
                    <Grid {...grid.gridExtUsrList.grid} data={fetch.getExtUsrList.data?.extAuthUsrList} render={render.extUsrList}/>
                </Group.Body>
            </Group>

        </Page>
    );
}